<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="审核" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class=""  style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}工单 -->
                    申请单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">
                       {{ formData.applyNo }}
                    </span>
                  </div>
                </div>

                <el-form-item label="审核结果" label-width="100px">
                  <el-radio-group v-model="formData.checkResult">
                    <el-radio v-for="item in stats"
                              :key="item.id" :label="item.label">
                      {{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="审核备注" label-width="100px">
                  <el-input class="annotate" type="textarea" :rows="5" placeholder="请输入内容" size="small" style="width: 90%"
                            v-model="formData.remark" clearable  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="orderFollowUp">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi','params'],
  components: {

  },
  created(){
    this.formData.id = this.params.dataId
    this.formData.applyNo = this.params.applyNo
  },
  data() {
    return {
      show3: false,
      showInRemark:"",
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      drawer: true,
      formData: {
        id: null,
        checkResult: '通过',
        remark: null,
        applyNo: '',
      },
      stats: [
        {id:2,label:'通过'},{id:3,label:'不通过'}],
    }
  },
  mounted() {

  },

  methods: {
    orderFollowUp(){
      this.$mask.open()

      console.log("审核参数:",this.formData)
      if(!this.formData.checkResult){
        this.$message({message: '请先选择审核结果', type: 'warning'});
        return;
      }
      if(this.formData.checkResult == "不通过" && !this.formData.remark){
        this.$message({message: '请输入审核备注', type: 'warning'});
        return;
      }
      request({
        url: api.wkGoodCommentApply.check,
        method: 'post',
        data:this.formData,
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if(response.data.type == "success"){
          this.$message({ message:response.data.content,type: 'success'});
          this.drawer = false;
          clearTimeout(this.timer);
          this.$emit('followUpCommentRemark', false)
        }else{
          this.$message({ message:response.data.content,type: 'warning'});
        }
      })
      this.$mask.close()

    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('followUpCommentRemark', 0)
    },
    handleClose() {
      this.drawer = false;
      this.$emit('followUpCommentRemark', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
    .table-detail tr {
      margin-bottom: 10px;
      display: block;
      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }
      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }}

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
  ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
  }
}
</style>
